module.exports = __webpack_public_path__ + "media/metronic/_theme/media/bg/bg-4-ae9a8f9c328a661bc8e0b8815cdf0a31.jpg";